import { memo, useState } from 'react'
import { Stack } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'
import {
  setOwnerForSharing,
  setSelectedTargetContentForMerging,
  setTenantForSharing,
} from '@tabeeb/modules/sessionsPage/actions'
import { ContentReviewRequest, ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getSourceReviewsByType } from '@tabeeb/modules/sessionsPage/selectors/contentSharings'
import ActiveReview from '../ActiveReview/ActiveReview'

interface ActiveReviewsProps {
  contentSharingType: ContentSharingModelType
}

const ActiveReviews: React.FC<ActiveReviewsProps> = ({ contentSharingType }) => {
  const dispatch = useDispatch()
  const [selectedReview, setSelectedReview] = useState<ContentReviewRequest | null>(null)
  const activeReviews = useSelector((state) => getSourceReviewsByType(state, { contentSharingType }))

  const setActiveReviewToUpdate = (review: ContentReviewRequest) => {
    dispatch(setTenantForSharing({ Id: review.ReviewerTenantId }))
    dispatch(setOwnerForSharing({ Id: review.ReviewerId }))
    dispatch(setSelectedTargetContentForMerging({ Id: review.TargetContentId }))
    setSelectedReview(review)
  }

  if (contentSharingType !== ContentSharingModelType.MergeForReview || !activeReviews?.length) {
    return null
  }

  return (
    <Stack spacing={1}>
      {activeReviews?.map((review: ContentReviewRequest) => (
        <ActiveReview
          key={review.Id}
          review={review}
          isSelected={review?.Id === selectedReview?.Id}
          setActiveReviewToUpdate={setActiveReviewToUpdate}
        />
      ))}
    </Stack>
  )
}

export default memo(ActiveReviews)

